'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderRegionStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  spread: _propTypes2.default.bool,
  horizontalAlign: _propTypes2.default.oneOf(['start', 'end', 'center', 'space-between', 'space-around']),
  verticalAlign: _propTypes2.default.oneOf(['stretch', 'center', 'start', 'end', 'baseline']),
  size: _propTypes2.default.oneOf(['blank', 'dense', 'default']),
  theme: _propTypes2.default.object
};
var defaultProps = {
  spread: false,
  horizontalAlign: 'start',
  verticalAlign: 'stretch',
  size: 'default'
};
/** PROP RECEIVERS */

var sizeProps = function sizeProps(_ref) {
  var size = _ref.size,
      themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = size === 'default' ? theme.reactackle.components.header.region.size : theme.reactackle.components.header.region.size[size];
  var paddingY = source.paddingY,
      paddingX = source.paddingX;
  return '\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n\n    &:first-child { padding-left: 0 }\n    &:last-child { padding-right: 0 }\n  ';
};

var mapMain = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  evenSpaceBetween: 'space-between',
  evenSpaceAround: 'space-around'
};
var mapCross = {
  start: 'flex-start',
  end: 'flex-end',
  center: 'center',
  stretch: 'stretch',
  baseline: 'baseline'
};

var alignProps = function alignProps(_ref2) {
  var horizontalAlign = _ref2.horizontalAlign,
      verticalAlign = _ref2.verticalAlign;
  return '\n  justify-content: ' + mapMain[horizontalAlign] + ';\n  align-items: ' + mapCross[verticalAlign] + ';\n';
};

var spread = function spread(_ref3) {
  var spread = _ref3.spread;
  return spread ? 'flex-grow: 1;' : '';
};
/** STYLES */


var HeaderRegionStyled = exports.HeaderRegionStyled = _styledComponents2.default.div.withConfig({
  displayName: 'HeaderRegionStyled'
})(['flex-shrink:0;display:flex;', ' ', ' ', ';'], sizeProps, alignProps, spread);

HeaderRegionStyled.propTypes = propTypes;
HeaderRegionStyled.defaultProps = defaultProps;
HeaderRegionStyled.displayName = 'HeaderRegionStyled';